"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var nanoid_1 = require("nanoid");

var index_1 = require("../../index");

var MediaThumbnail = function MediaThumbnail(_a) {
  var className = _a.className,
      checkbox = _a.checkbox,
      isDisabled = _a.isDisabled,
      isSelected = _a.isSelected,
      _onClick = _a.onClick,
      src = _a.src,
      _b = _a.alt,
      alt = _b === void 0 ? '' : _b,
      other = __rest(_a, ["className", "checkbox", "isDisabled", "isSelected", "onClick", "src", "alt"]);

  var classes = classnames_1.default(className, 'media-thumbnail', {
    selected: isSelected
  }, {
    disabled: isDisabled
  }, {
    'cursor-pointer': typeof _onClick === 'function' && !isDisabled
  });
  var testId = "media-thumbnail-" + nanoid_1.nanoid();
  return react_1.default.createElement("div", __assign({}, other, {
    className: classes,
    "data-test-id": "" + testId,
    onClick: function onClick() {
      return !isDisabled && typeof _onClick === 'function' && _onClick(src);
    }
  }), react_1.default.createElement("div", {
    className: "media-thumbnail-inner d-flex justify-content-center overflow-hidden align-items-center bg-gray-300 rounded-sm"
  }, react_1.default.createElement("img", {
    className: "mw-100 mh-100",
    src: src,
    alt: alt
  })), checkbox && react_1.default.createElement(index_1.FormGroup, {
    className: "media-thumbnail-checkbox-group",
    isCheck: true
  }, react_1.default.createElement(index_1.FormInput, {
    type: "checkbox",
    checked: isSelected,
    id: testId + "-checkbox",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  }), react_1.default.createElement(index_1.FormLabel, {
    isCheck: true,
    htmlFor: testId + "-checkbox"
  }, ' ')));
};

exports.default = MediaThumbnail;